import React from 'react';

import styled from 'styled-components';

export const FilterSelectAdmin = ({
  label,
  placeholder = '',
  labelColor = '#646363',
  onChangeItem = () => {},
  value,
  options = [],
  optionLabel = '',
  formatLabel = null,
  returnAsObject = true,
  width = "inherit",
  styleSelectContainer,
  name,

}) => {
  const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: ${(props) => props?.width ?? 'auto'};
  `;
  const LabelContainer = styled.div`
    color: ${labelColor};
    font-family: 'Montserrat',sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    display: flex;
  `;
  const SelectContainer = styled.select`
    background: rgba(196, 196, 196, 0.1);
    border: 0.5px solid #646363 !important;
    height: 26px;
    padding: 6px 11px;
    font-size: 14px;
    line-height: 17px;
    outline-offset: 0px;
  `;
  
  return (
      <Container width={width}>
        <LabelContainer>
          <label htmlFor={label}>
            {label}
            <br/>
          </label>
        </LabelContainer>
        <SelectContainer
            name={name}
            style={styleSelectContainer}
            placeholder={placeholder}
            id={label}
            onChange={onChangeItem}
            value={!!value ? JSON.stringify(value) : ''}
        >
          {!!placeholder && <option value={''}>{placeholder}</option>}
          {options?.length && options?.map((item, index) => {
            const itemLabel = !!optionLabel && item?.hasOwnProperty(optionLabel) ? item[optionLabel] : item;
            const itemValue = returnAsObject ? JSON.stringify(item) : JSON.stringify(itemLabel);
            const finalLabel = formatLabel ? returnAsObject ? formatLabel(item) : formatLabel(itemLabel)  : itemLabel
            return (
                <option key={index} value={itemValue} title={finalLabel}>
                  {finalLabel}
                </option>
            );
          })}
        </SelectContainer>
      </Container>
  );
};
